import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {
  doc,
  collection,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase_conf";
import { Button, TextField } from "@mui/material";

const columns = [
  { id: "full_name", label: "Full Name", minWidth: 170 },
  {
    id: "address",
    label: "Geo Location",
    minWidth: 170,
    align: "left",
  },
  {
    id: "contact",
    label: "Contact Number",
    minWidth: 170,
    align: "left",
  },
  {
    id: "user_type",
    label: "User Type",
    minWidth: 170,
    align: "center",
  },
  // {
  //   id: "timestamp",
  //   label: "Date Joined",
  //   minWidth: 170,
  //   align: "left",
  //   // format: (value) => value.toLocaleString("en-US"),
  // },
  {
    id: "action",
    label: "Action",
    minWidth: 250,
    align: "center",
  },
];

export default function TableView() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [users, setUsers] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpdateRowID, setIsUpdateRowID] = useState("");

  // fetch users list from firebase
  // temporary comment 
  useEffect(() => {
    let isMounted = true;
    const q = query(collection(db, "users"), orderBy("timestamp", "desc"));
    onSnapshot(q, (snapshot) => {
      if (isMounted) {
       setUsers(
          snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        );
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  /* UPDATE */
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const studentDoc = doc(db, "users", isUpdateRowID);
    await updateDoc(studentDoc, {
      full_name: data.get("full_name"),
      contact: data.get("contact"),
      user_type: data.get("user_type"),
      address: data.get("address"),
    });
    setIsUpdateRowID("");
    setIsUpdate(false);
  };

  /* DELETE */
  const deleteUser = (id, full_name) => {
    const text = `Are you sure you want to delete this user '${full_name}'?`;
    console.log(full_name);
    if (window.confirm(text) === true) {
      const studentDoc = doc(db, "users", id);
      deleteDoc(studentDoc);
    } 
  };

  const handleEdit = (rowID) => {
    setIsUpdateRowID(rowID);
    setIsUpdate(true);
  };

  const handleCancel = () => {
    setIsUpdateRowID("");
    setIsUpdate(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <>
    <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: 0, marginTop:"20px"}}>
      <Typography variant="h6" gutterBottom textAlign="center">Users Table</Typography>
      <TableContainer sx={{ maxHeight: "75vh", minHeight: "75vh" }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {users
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return column.id === "action" ? (
                          <TableCell key={column.id} align={column.align}>
                            {isUpdate && isUpdateRowID === row.id ? (
                              <>
                                <button type="submit" className="btn-save">
                                  <span className="btn-save-icon">
                                    {<CheckIcon />}
                                  </span>
                                  SAVE
                                </button>
                                <Button
                                  color="error"
                                  variant="outlined"
                                  startIcon={<CloseIcon />}
                                  type="button"
                                  onClick={handleCancel}
                                >
                                  CANCEL
                                </Button>
                              </>
                            ) : (
                              <>
                                <Button
                                  onClick={() => {
                                    handleEdit(row.id);
                                  }}
                                  color="warning"
                                  variant="outlined"
                                  startIcon={<EditIcon />}
                                >
                                  EDIT
                                </Button>
                                <Button
                                  color="error"
                                  variant="outlined"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => {
                                    deleteUser(row.id, row.full_name);
                                  }}
                                >
                                  DELETE
                                </Button>
                              </>
                            )}
                          </TableCell>
                        ) : isUpdateRowID === row.id ? (
                          <TableCell key={column.id} align={column.align}>
                            <TextField
                              required
                              fullWidth
                              name={column.id}
                              label={column.label}
                              type="text"
                              id={column.id}
                              defaultValue={value}
                              variant={"standard"}
                            />
                          </TableCell>
                        ) : (
                          <TableCell key={column.id} align={column.align}>
                            {value === "2" ? "End-user": value === "3"? "Responder": value === "1"? "Admin": value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </Box>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={users.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  </>
  );
}

